<!--  -->
<template>
  <div class="CorporateGovernance">
    <div class="governance-main">
      <ul class="governance-select">
        <li
          :class="{ active: index === onSelect }"
          v-for="(item, index) in governanceSelect"
          :key="index"
          @click="onPitch(index, item.id)"
        >
          <h1>{{ item.title }}</h1>
          <div class="download" v-if="item.pdf">
            <a :href="item.pdf" target="_blank">{{
              download
            }}</a>
          </div>
        </li>
      </ul>

      <ul class="governance-list">
        <li v-for="(item, index) in governanceList" :key="index">
          <h1>{{ item.title }}</h1>
          <p>
            {{ item.msg }}
          </p>
          <router-link to="/" v-show="item.fanwei">
            <span>{{ item.fanwei }} ></span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      aid: 0, //文章ID
      governanceSelect: [
        /* 
        {
          id: "",
          title: "董事名单中其角色和职能",
        },
        {
          id: "",
          title: "公司章程",
        },
        {
          id: "",
          title: "股东提名人选参选董事的程序",
        },
        {
          id: "",
          title: "股东提名人选参选董事的程序",
        },
       */
      ],
      governanceList: [/* 
        {
          title: "董事委员会",
          msg: "昆明医疗的董事会传授若干职责予多个委员会。根据有关中国法律及法规以及上市规则附录十四企业管制守则，本公司已成立三个董事委员会，即审计委员会/薪酬与考核委员会以及提名委员会。",
          fanwei: "",
        },
        {
          title: "董事委员会",
          msg: "昆明医疗的董事会传授若干职责予多个委员会。根据有关中国法律及法规以及上市规则附录十四企业管制守则，本公司已成立三个董事委员会，即审计委员会/薪酬与考核委员会以及提名委员会。",
          fanwei: "职权范围",
        },
        {
          title: "董事委员会",
          msg: "昆明医疗的董事会传授若干职责予多个委员会。根据有关中国法律及法规以及上市规则附录十四企业管制守则，本公司已成立三个董事委员会，即审计委员会/薪酬与考核委员会以及提名委员会。",
          fanwei: "职权范围",
        },
        {
          title: "董事委员会",
          msg: "昆明医疗的董事会传授若干职责予多个委员会。根据有关中国法律及法规以及上市规则附录十四企业管制守则，本公司已成立三个董事委员会，即审计委员会/薪酬与考核委员会以及提名委员会。",
          fanwei: "职权范围",
        },
       */],
      onSelect: 0,
      download: "", //下载
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onPitch(val, id) {
      this.onSelect = val;
      //根据点击的id获取新数据
      this.get_detail(id);
    },
    //1.得到文章列表
    getList() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 20,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.governanceSelect.push({
                id: k.id,
                title: k.title,
                pdf: k.filepath,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.文章详情
    get_detail(id) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_article",
          article_id: id,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            if (obj.data.msgs) {
              that.governanceList = [];
              var sign = obj.data.sign.split("@");
              var arrs = obj.data.msgs.split("<br />");
              $.each(sign, function (i, k) {
                that.governanceList.push({
                  title: sign[i],
                  msg: arrs[i],
                });
              });
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.download = obj.data["xz"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.onPitch(0, 264);
    this.getList();
    this.get_fanyi();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.CorporateGovernance {
  width: 100%;
  .governance-main {
    width: $main-width;
    margin: 0 auto;
    .governance-select {
      width: 100%;
      display: flex;
      margin: 30px 0;
      li {
        width: 24%;
        margin: 0 10px;
        cursor: pointer;
        padding: 30px 42px 20px 22px;
        background: #ffffff;
        h1 {
          display: block;
          position: relative;
          color: #333;
          font-size: 1.2rem;
          line-height: 1.3;
          letter-spacing: 2px;
          margin-left: 20px;
        }
        h1::before {
          content: "";
          position: absolute;
          height: 100%;
          width: 4px;
          border-radius: 2px;
          background: #999999;
          left: -20px;
        }
        .download {
          text-align: center;
          width: 95px;
          padding: 4px 0;
          color: #fefefe;
          border-radius: 5px;
          background: #999999;
          margin-top: 20px;
        }
      }
      .active {
        background: #fffef3;
        h1::before {
          background: #f8ad17;
        }
        .download {
          background: #f8ad17;
        }
      }
    }

    .governance-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 48%;
        padding: 30px 120px 40px;
        margin: 44px 0;
        background: #ffffff;
        box-shadow: 0px 0px 9px 0px rgba(75, 75, 75, 0.1);
        transition: 0.3s;
        h1 {
          display: block;
          position: relative;
          color: #333;
          font-size: 1.1rem;
          padding-left: 18px;
        }
        h1::before {
          content: "";
          position: absolute;
          left: 0;
          height: 100%;
          width: 4px;
          background: #0069b5;
          border-radius: 2px;
        }
        p {
          font-size: 0.9rem;
          color: #161616;
          letter-spacing: 1px;
          line-height: 1.6;
          font-weight: 200;
          margin: 25px 0;
        }
        a {
          color: #193b95;
          font-size: 0.8rem;
          font-weight: 500;
        }
      }
      li:hover {
        box-shadow: 0px 0px 27px 0px rgba(75, 75, 75, 0.3);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/investor/CorporateGovernance.vue